(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mori-instagram-proof"] && !Shopify.designMode) return;
  try {
    
  class MoriInstagramProof extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.arrows = this.querySelectorAll('[data-direction]');
      this.arrows.forEach((button) => {
        button.addEventListener('click', () => this.page(Number(button.dataset.direction)));
      });
      // Load the photos once the band is within half a screen, but not before the page has loaded or the
      // visitor has started scrolling, so they never hold up the product photos at the top of the page
      this.loadObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.loadObserver.disconnect();
        this.querySelectorAll('img[data-srcset]').forEach((image) => {
          image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          image.removeAttribute('data-srcset');
        });
      }, { rootMargin: '50% 0px' });
      const watch = () => {
        if (this.watching) return;
        this.watching = true;
        this.loadObserver.observe(this);
      };
      if (document.readyState === 'complete') {
        watch();
      } else {
        window.addEventListener('load', watch, { once: true });
        window.addEventListener('scroll', watch, { once: true, passive: true });
      }

      this.sets = this.rail.querySelectorAll('[data-set-start]');
      this.looping = this.sets.length === 3;

      // Re-centre on the middle set when the rail width changes, then decide whether arrows earn their place
      this.lastWidth = 0;
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.rail.clientWidth;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        if (this.looping) this.rail.scrollLeft = this.setWidth();
        const overflowing = (this.looping ? this.setWidth() : this.rail.scrollWidth) > width + 2;
        this.arrows.forEach((button) => { button.hidden = !overflowing; });
      });
      this.resizeObserver.observe(this.rail);

      if (this.looping) {
        // scrollend waits for swipe momentum to finish; older Safari falls back to a short pause in scrolling
        if ('onscrollend' in window) {
          this.rail.addEventListener('scrollend', () => this.recentre());
        } else {
          this.rail.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.recentre(), 150);
          }, { passive: true });
        }
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.loadObserver?.disconnect();
    }

    // Distance from one copy of the posts to the next
    setWidth() {
      return this.sets[1].offsetLeft - this.sets[0].offsetLeft;
    }

    // The copies either side look identical, so jumping a whole set back to the middle is invisible
    recentre() {
      const width = this.setWidth();
      if (this.rail.scrollLeft < width - 1) this.rail.scrollLeft += width;
      else if (this.rail.scrollLeft >= width * 2 - 1) this.rail.scrollLeft -= width;
    }

    // Moves a full view of posts; the copies either side keep it going round in both directions
    page(direction) {
      const rail = this.rail;
      if (this.looping) {
        this.recentre();
      } else {
        const end = rail.scrollWidth - rail.clientWidth;
        if (direction > 0 && rail.scrollLeft >= end - 2) return rail.scrollTo({ left: 0, behavior: 'smooth' });
        if (direction < 0 && rail.scrollLeft <= 2) return rail.scrollTo({ left: end, behavior: 'smooth' });
      }
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollTo({ left: rail.scrollLeft + direction * (rail.clientWidth + gap), behavior: 'smooth' });
    }
  }
  if (!customElements.get('mori-instagram-proof')) customElements.define('mori-instagram-proof', MoriInstagramProof);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mori-product-reviews"] && !Shopify.designMode) return;
  try {
    
  class MoriProductReviews extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.querySelectorAll('[data-direction]').forEach((button) => {
        button.addEventListener('click', () => this.page(Number(button.dataset.direction)));
      });
      this.visibleOnMobile = 3;
      this.moreButton = this.querySelector('[data-more]');
      this.moreButton.addEventListener('click', () => {
        this.visibleOnMobile += 3;
        this.updateMore();
      });
      this.updateMore();
      if (this.dataset.preview !== 'true') this.loadReviews();
    }

    // Mobile stacks the reviews and reveals them three at a time; desktop CSS ignores the class
    updateMore() {
      const items = Array.from(this.rail.children);
      items.forEach((item, index) => item.classList.toggle('mori-review--more', index >= this.visibleOnMobile));
      this.moreButton.hidden = items.length <= this.visibleOnMobile;
    }

    // Moves a full view of cards, looping back round at either end
    page(direction) {
      const rail = this.rail;
      const end = rail.scrollWidth - rail.clientWidth;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      let left = rail.scrollLeft + direction * (rail.clientWidth + gap);
      if (direction > 0 && rail.scrollLeft >= end - 2) left = 0;
      if (direction < 0 && rail.scrollLeft <= 2) left = end;
      rail.scrollTo({ left, behavior: 'smooth' });
    }

    // The metafield only carries the latest page of reviews, so fetch more to fill the rail with qualifying ones.
    async loadReviews() {
      const minRating = Number(this.dataset.minRating || 5);
      const limit = Number(this.dataset.limit || 12);
      const reviews = [];
      let summary;
      try {
        for (let page = 1; page <= 5 && reviews.length < limit; page += 1) {
          const response = await fetch(`${this.dataset.endpoint}&page=${page}&per_page=20`);
          if (!response.ok) break;
          const data = await response.json();
          summary = summary || data;
          reviews.push(...(data.reviews || []).filter((review) => Number(review.rating) >= minRating));
          if (!data.pagination || page >= Number(data.pagination.total_pages || 0)) break;
        }
      } catch (error) {
        return;
      }
      if (summary) this.updateSummary(summary);
      if (!reviews.length) return;
      this.render(reviews.slice(0, limit));
    }

    // The metafield count can lag behind Judge.me, so refresh the header from the live feed.
    updateSummary(data) {
      const count = Number(data.number_of_reviews || 0);
      if (!count) return;
      const average = Number(data.average_rating).toFixed(1);
      const stars = this.querySelector('[data-summary-stars]');
      const text = this.querySelector('[data-summary-text]');
      stars.style.setProperty('--mori-rating', `${average * 20}%`);
      text.textContent = `${average} out of 5`;
      stars.hidden = false;
      text.hidden = false;
    }

    // First name and last initial only, so customers aren't named in full
    shortName(name) {
      const parts = (name || '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return 'Mori customer';
      if (parts.length === 1) return parts[0];
      return `${parts[0]} ${parts[parts.length - 1].charAt(0).toUpperCase()}.`;
    }

    // Date only, in UK time to match the Liquid render: Judge.me stores imported reviews at midnight UK time,
    // which is 23:00 UTC the day before. Months are spelled out here because en-GB gives "Sept"
    reviewDate(value) {
      const date = new Date(value);
      if (!value || Number.isNaN(date.getTime())) return null;
      const parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'numeric', year: 'numeric' })
        .formatToParts(date)
        .forEach(({ type, value: part }) => { parts[type] = part; });
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = String(parts.month).padStart(2, '0');
      const day = String(parts.day).padStart(2, '0');
      return { iso: `${parts.year}-${month}-${day}`, label: `${Number(parts.day)} ${months[Number(parts.month) - 1]} ${parts.year}` };
    }

    render(reviews) {
      this.rail.replaceChildren(...reviews.map((review) => this.card(review)));
      this.updateMore();
      this.hidden = false;
    }

    card(review) {
      const text = (html) => new DOMParser().parseFromString(html || '', 'text/html').body.textContent.trim();
      const item = document.createElement('li');
      item.className = 'mori-review';

      const rating = document.createElement('p');
      rating.className = 'mori-review__rating';
      rating.setAttribute('aria-label', `${review.rating} out of 5 stars`);
      const stars = document.createElement('span');
      stars.className = 'mori-stars';
      stars.style.setProperty('--mori-rating', `${Number(review.rating) * 20}%`);
      stars.setAttribute('aria-hidden', 'true');
      const score = document.createElement('span');
      score.textContent = `${review.rating}/5`;
      score.setAttribute('aria-hidden', 'true');
      rating.append(stars, score);
      item.append(rating);

      const title = text(review.title);
      if (title) {
        const heading = document.createElement('h3');
        heading.className = 'mori-review__title';
        heading.textContent = title;
        item.append(heading);
      }

      const body = document.createElement('p');
      body.className = 'mori-review__body';
      body.textContent = text(review.body || review.body_html);
      item.append(body);

      const footer = document.createElement('div');
      footer.className = 'mori-review__footer';
      const author = document.createElement('p');
      author.className = 'mori-review__author';
      author.textContent = this.shortName(review.reviewer?.name || review.reviewer_name);
      footer.append(author);

      const meta = document.createElement('p');
      meta.className = 'mori-review__meta';
      // Only where Judge.me itself flags the review as verified
      if (review.verified_buyer === true) {
        const verified = document.createElement('span');
        verified.className = 'mori-review__verified';
        verified.textContent = 'Verified buyer';
        meta.append(verified);
      }
      const date = this.reviewDate(review.created_at);
      if (date) {
        const time = document.createElement('time');
        time.dateTime = date.iso;
        time.textContent = date.label;
        meta.append(time);
      }
      if (meta.childElementCount) footer.append(meta);
      item.append(footer);
      return item;
    }
  }
  if (!customElements.get('mori-product-reviews')) customElements.define('mori-product-reviews', MoriProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mori-social-proof"] && !Shopify.designMode) return;
  try {
    
  class MoriSocialProof extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.lightbox = this.querySelector('[data-lightbox]');
      this.frame = this.querySelector('[data-frame]');
      this.speed = Number(this.dataset.speed || 18);
      this.paused = true;
      this.offset = 0;
      this.resumeTimer = null;

      this.querySelectorAll('[data-embed], [data-video]').forEach((tile) => {
        tile.addEventListener('click', (event) => {
          // Leave modified clicks alone so the post can still be opened directly
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          event.preventDefault();
          this.open(tile.dataset);
        });
      });
      this.querySelector('[data-close]')?.addEventListener('click', () => this.lightbox.close());
      this.lightbox?.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.lightbox.close();
      });
      // Clearing the frame stops playback and releases any third-party code
      this.lightbox?.addEventListener('close', () => this.frame.replaceChildren());

      this.setupAutoScroll();
    }

    disconnectedCallback() {
      if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
      this.observer?.disconnect();
    }

    open({ video, embed }) {
      let player;
      if (video) {
        player = document.createElement('video');
        player.src = video;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
      } else {
        player = document.createElement('iframe');
        player.src = embed;
        player.allow = 'autoplay; clipboard-write; encrypted-media; picture-in-picture';
        player.allowFullscreen = true;
        player.setAttribute('scrolling', 'no');
        player.title = 'Customer video';
      }
      this.frame.replaceChildren(player);
      this.lightbox.showModal();
    }

    setupAutoScroll() {
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      // The rail only loops cleanly when the duplicated half overflows the viewport
      if (motionQuery.matches || this.rail.scrollWidth / 2 <= this.rail.clientWidth) return;

      ['pointerenter', 'focusin'].forEach((event) => {
        this.rail.addEventListener(event, () => this.hold());
      });
      ['pointerleave', 'focusout'].forEach((event) => {
        this.rail.addEventListener(event, () => this.release());
      });
      // A swipe or wheel scroll should hand control over for a moment
      this.rail.addEventListener('pointerdown', () => this.hold(), { passive: true });
      this.rail.addEventListener('touchend', () => this.release(2500), { passive: true });
      this.rail.addEventListener('wheel', () => this.release(2500), { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.hold();
        else this.release(0);
      });

      // Only animate while the section is on screen
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.start();
        });
      });
      this.observer.observe(this);
      this.paused = false;
    }

    hold() {
      clearTimeout(this.resumeTimer);
      this.paused = true;
    }

    release(delay = 0) {
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(() => {
        this.paused = false;
        this.start();
      }, delay);
    }

    start() {
      if (this.frameRequest || !this.visible) return;
      this.last = null;
      this.frameRequest = requestAnimationFrame((now) => this.tick(now));
    }

    tick(now) {
      this.frameRequest = null;
      if (!this.visible) return;

      const half = this.rail.scrollWidth / 2;
      // Resync if the reader scrolled the rail themselves
      if (Math.abs(this.rail.scrollLeft - this.offset) > 2) this.offset = this.rail.scrollLeft;

      if (!this.paused && this.last !== null) {
        this.offset += (this.speed * (now - this.last)) / 1000;
        if (this.offset >= half) this.offset -= half;
        this.rail.scrollLeft = this.offset;
      }
      this.last = now;
      this.frameRequest = requestAnimationFrame((next) => this.tick(next));
    }
  }
  if (!customElements.get('mori-social-proof')) customElements.define('mori-social-proof', MoriSocialProof);

  } catch(e) { console.error(e); }
})();
})();
